import { render, staticRenderFns } from "./DebugDialog.vue?vue&type=template&id=4dbc6b48&scoped=true&"
import script from "./DebugDialog.vue?vue&type=script&lang=js&"
export * from "./DebugDialog.vue?vue&type=script&lang=js&"
import style0 from "./DebugDialog.vue?vue&type=style&index=0&id=4dbc6b48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbc6b48",
  null
  
)

export default component.exports